export const storeAccessToken = (token) => localStorage.setItem("token", token);

export const getAccessToken = () => localStorage.getItem("token");

export const removeAccessToken = () => {
  localStorage.removeItem("token");
};

export const handleTokenExpiry = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("data");
  sessionStorage.setItem("session_expired", "true");
  window.location.href = "/";
};

export const isTokenExpiryResponse = (response) => {
  if (!response) return false;
  if (response.status === 401) return true;
  if (response.status === 500) {
    const msg = (response.data?.message || response.data?.error?.message || "").toLowerCase();
    const name = response.data?.error?.name || "";
    return name === "TokenExpiredError" || msg.includes("jwt expired") || msg.includes("token has expired");
  }
  return false;
};
